exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select-district-school-and-classroom {\n  margin-bottom: 20px;\n  padding-top: 0;\n  padding-bottom: 5px;\n}\n.select-district-school-and-classroom > div {\n  margin-bottom: 10px;\n}\n@media print {\n  .select-district-school-and-classroom {\n    display: none;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/a2i/styles/SelectDistrictSchoolAndClassroom.styl
// module id = 928
// module chunks = 0 1